import { render, staticRenderFns } from "./MapMarkerArtSpaceIcon.vue?vue&type=template&id=f98e0042&"
import script from "./MapMarkerArtSpaceIcon.vue?vue&type=script&lang=js&"
export * from "./MapMarkerArtSpaceIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports